// import axios from 'axios'
import { post, put, get, remove, patch } from '@/api/api'

export const actions = {
  fetchEcran({ commit }) {
    return get(`/canal/screen/`)
      .then(({ data }) => {
        commit('addEcrans', data)
      })
  },
  async fetchEcranPage({commit}, params = {}) {
    const { page = 0, size = 10, sort = '', name = '', code = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort, 
      ...(code && { code }),
      ...(name && { name }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/screen/page?${queryParams}`);
    commit("addEcranPage", data)
    return data;
  },
  createEcran ({ commit }, ecran) {
    return post('/canal/screen', ecran)
      .then(({ data }) => {
        commit('addEcran', data)
      })
  },
  updateEcran ({ commit }, ecran) {
    return put(`/canal/screen/${ecran.id}`, ecran)
      .then(({ data }) => {
        commit('replaceEcran', data)
      })
  },
  createOrUpdateEcran ({ dispatch }, ecran) {
    if (ecran.id !== undefined) {
      return dispatch('updateEcran', ecran)
    } else {
      return dispatch('createEcran', ecran)
    }
  },
  deleteEcran ({ commit}, ecran) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return remove(`/canal/screen/${ecran.id}`)
      .then(({ data }) => {
        
      })
  },
  selectecran ({ commit }, ecran) {
    commit('setEcran', ecran)
  }
}
